import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Removed: import Navbar from "../components/Navbar";
import "../styles/FullContent.css";
import "../styles/OtherResults.css";

const OtherResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { dbResults = [], district, state, country } = location.state || {};

  return (
    <div className="other-results-page">
      {/* Removed page-level <Navbar /> to avoid duplication; App.js already provides it */}
      <div className="other-results-container">
        {/* <div className="results-header">
            <div className="header-content">
              <h1 className="main-title">
                <span className="title-icon">📋</span>
                Database Results
              </h1>
              <p className="subtitle">
                Related legal information from our comprehensive database
              </p>
            </div>
        </div> */}

        <div className="results-content">
          {!location.state ? (
            <div className="error-state">
              <div className="error-icon">⚠️</div>
              <h2>No Data Available</h2>
              <p>This usually happens when you refresh the page or navigate directly to this URL.</p>
              <button 
                className="primary-btn"
                onClick={() => navigate("/search")}
              >
                ← Go Back to Search
              </button>
            </div>
          ) : dbResults.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h2>No Database Results Found</h2>
              <p>We couldn't find any matching results in our database for your query.</p>
              <div className="suggestions">
                <h3>Suggestions:</h3>
                <ul>
                  <li>Try different keywords or phrases</li>
                  <li>Check if you selected the correct country and state</li>
                  <li>Use more general terms</li>
                  <li>Try the AI search for detailed answers</li>
                </ul>
              </div>
              <button 
                className="primary-btn"
                onClick={() => navigate("/search")}
              >
                ← Try Different Search
              </button>
            </div>
          ) : (
            <div className="results-section">
              <div className="results-summary">
                <div className="summary-card">
                  <div className="summary-icon">📊</div>
                  <div className="summary-content">
                    <h3>Found {dbResults.length} Related Result{dbResults.length !== 1 ? 's' : ''}</h3>
                    <p>Click on any result to view detailed information</p>
                  </div>
                </div>
              </div>

              <div className="results-grid">
                {dbResults.map((result, idx) => (
                  <div
                    key={idx}
                    className="result-card"
                    onClick={() =>
                      navigate("/full-content", {
                        state: {
                          content: result.content || "",
                          query: result.query || "No query available",
                          summary: result.summary || "",
                          lawCategory: result.lawCategory || "Not Categorized",
                          country: result.country || country || "Unknown country",
                          state: result.state || state || "Unknown state",
                          district: district || "Unknown district",
                          dbResults,
                        },
                      })
                    }
                  >
                    <div className="card-header">
                      <div className="query-badge">
                        <span className="badge-icon">❓</span>
                        Query
                      </div>
                      <div className="card-number">#{idx + 1}</div>
                    </div>
                    
                    <div className="card-content">
                      <h4 className="query-text">{result.query}</h4>
                      
                      <div className="content-preview">
                        <p>{result.content.length > 200 
                          ? `${result.content.substring(0, 200)}...` 
                          : result.content}
                        </p>
                      </div>
                      
                      <div className="location-info">
                        <div className="location-item">
                          <span className="location-icon">🌍</span>
                          <span>{result.country}</span>
                        </div>
                        {result.state && (
                          <div className="location-item">
                            <span className="location-icon">🏛️</span>
                            <span>{result.state}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div className="card-footer">
                      <button className="view-btn">
                        <span>View Details</span>
                        <span className="arrow">→</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtherResults;